import { WidgetsServicesReportListMain } from '@/widgets/services-report-list';

export const PagesServicesVideoMain = () => <WidgetsServicesReportListMain reportType="VIDEO" />;
